import React from 'react';
import { useRouter } from 'next/router';
import ImageCat from '../../../public/static/error/cat.png';
import { RSButton } from 'src/reservation-page/RSButton';
import { useIntl } from 'react-intl';

const RateLimitExceeded = () => {
  const router = useRouter();
  const handleClick = () => {
    router.back();
  };
  const intl = useIntl();

  return (
    <div className="flex justify-center px-2 text-center">
      <div className="pc:w-[426px]">
        <img
          src={ImageCat}
          alt="Error"
          className="pc:mt-10 mb-4 mt-5 w-[250px]"
        />
        <h1 className="text-32 pc:text-28 mb-2 mt-0 font-bold">
          {intl.formatMessage({
            defaultMessage:
              '現在アクセスが集中しているためページを表示できません',
            id: 'G4zrs2',
            description: 'src/templates/RateLimitExceeded/index.tsx',
          })}
        </h1>
        <div className="text-16 pc:text-15 mb-4 font-light">
          {intl.formatMessage({
            defaultMessage:
              'ご迷惑をおかけして誠に申し訳ございませんが、しばらく時間を置いてからアクセスしていただきますようお願い申し上げます。',
            id: 'J7kfQb',
            description: 'src/templates/RateLimitExceeded/index.tsx',
          })}
        </div>
        <RSButton variant="outline" onClick={handleClick}>
          {intl.formatMessage({
            defaultMessage: '前のページに戻る',
            id: 'cB40JF',
            description: 'src/templates/RateLimitExceeded/index.tsx',
          })}
        </RSButton>
      </div>
    </div>
  );
};

export default RateLimitExceeded;
